import { Dropdown, DropdownItem } from '@/components/common/dropdown';
import { AudioPlayContext } from '@/contexts/AudioPlayContext';
import { CommonConfigContext } from '@/contexts/ConfigContext';
import { Locale, LocaleCode, getLocaleByCode } from '@/models/Locale';
import { getMainUserState } from '@/modules/main/selector';
import { RootState } from '@/store/store';
import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
type HandleChangeLanguage = (language: string) => void;
type LanguageSelectorProps = {
    language: string;
    handleChangeLanguage: HandleChangeLanguage;
};
export const LanguageSelector = (props: LanguageSelectorProps) => {
    const { language, handleChangeLanguage } = props;
    const btnLanguageText = getLocaleByCode('long', language).fullName;
    const [locales, setLocales] = useState<Array<LocaleCode>>([]);
    const { playButtonAudio } = useContext(AudioPlayContext);
    const { langOnly, langExclude } = useContext(CommonConfigContext);
    const { LobbyCode: serLobbyCode } = useSelector((state: RootState) =>
        getMainUserState(state)
    );
    useEffect(() => {
        const l = Object.values(Locale).filter(l => {
            const shortLang = l.short;
            if (
                langExclude[shortLang]?.lobby?.includes(serLobbyCode) ||
                langExclude[shortLang]?.lobby?.includes('all')
            )
                return false;
            if (langOnly[l.short]) {
                if (langOnly[l.short]?.includes(serLobbyCode)) {
                    return true;
                }
                return false;
            }
            return true;
        });
        setLocales(l);
    }, []);
    const onLanguageChange = (lang: string) => {
        handleChangeLanguage(lang);
        playButtonAudio();
    };
    return (
        <Dropdown
            className="language-selector"
            placeholder={btnLanguageText}
            disableTranslation
        >
            {locales.map((l, i) => {
                return (
                    <DropdownItem
                        onClick={() => onLanguageChange(l.long)}
                        key={`language-selector-${i}`}
                        text={l.fullName}
                        isChecked={language === l.long}
                    />
                );
            })}
        </Dropdown>
    );
};
